export default __webpack_public_path__ + "static/media/alertIconRed.dc9a587b.svg";